import { atomWithStorage } from 'jotai/utils';
export const collapsedAtom = atomWithStorage('layout-collapsed', false);
export const openKeysAtom = atomWithStorage('layout-openKeysAtom', []);